module.exports = __webpack_public_path__ + "static/media/ico_care.10b7e768.svg";